export default {
  listContract: state => state.contract_list,
  listContractId: state => state.contract_select_object_ids,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/store/getters.js